export default __webpack_public_path__ + "assets/json/drone-right.20c02e.json";